/*
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-21 17:59:27
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-02-06 08:42:15
 */
import Vue from "vue";
import VueRouter from "vue-router";
import { getCookie } from "@/utils/cookies";
Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "*404",
    component: () => import("@/views/error/404"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login"),
  },
  {
    path: "/cardCheck",
    name: "CardCheck",
    component: () => import("@/views/cardCheck"),
  },
  {
    path: "/downLoadCard",
    name: "DownLoadCard",
    component: () => import("@/views/downLoadCard"),
  },
  {
    path: "/faceRecognition",
    name: "FaceRecognition",
    component: () => import("@/views/faceRecognition"),
  },
];
const files = require.context("./modules/", false, /\.router.js$/);
files.keys().map((v) => {
  const file = files(v).default || files(v);
  routes.push(...file);
});

document.title = "职业技能等级证书考试系统";
const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  //注册一个全局守卫，作用是在路由跳转前，对路由进行判断，防止未登录的用户跳转到其他需要登录的页面去
  // if (to.meta.role) {
  if (getCookie("myToken") || to.path.indexOf("/application") != -1) {
    next();
  } else {
    if (to.path !== "/login") {
      // 如果没有登录，但你访问其他需要登录的页面，那我就让你跳到登录页面去
      next({ path: "/login" });
    } else {
      // 如果没有登录，但你访问的login，那就不干涉你，让你访问
      next();
    }
  }
  // }
});

export default router;
